import {
  KeyIcon,
  LogoutIcon,
  MarketPlaceIcon,
  MentalHealthIcon,
  MovementsIcon,
  NutritionIcon,
  ProfileIcon,
  RewardsIcon,
} from "../icons";
import { COLORS } from "./colors";

export const SUB_MENU_LIST = [
  {
    name: "My Profile",
    navigateTo: "/profile",
    icon: <ProfileIcon height={20} width={20} fill={COLORS.textGray} />,
  },
  {
    name: "Change Password",
    // navigateTo: "/profile",
    icon: (
      <KeyIcon
        height={20}
        width={20}
        fill={COLORS.white}
        stroke={COLORS.textGray}
      />
    ),
  },
  {
    name: "Logout",
    navigateTo: "/",
    icon: <LogoutIcon height={20} width={20} fill={COLORS.textGray} />,
  },
];

export const APP_PATHS = {
  Marketplace: "/marketplace",
  MentalHealth: "/mental-health",
  Nutrition: "/nutrition",
  Movement: "/movement",
  Rewards: "/rewards",
};

export const APP_COLORS = {
  Marketplace: "marketGray",
  MentalHealth: "mentalGreen",
  Nutrition: "nutrition",
  Movement: "movementPink",
  Rewards: "rewardRed",
};

export const APP_USERID = {
  Marketplace: "marketplace_user_id",
  MentalHealth: "mentalhealth_user_id",
  Nutrition: "nutrition_user_id",
  Movement: "movement_user_id",
  Rewards: "rewards_user_id",
};

export const APP_ICONS = {
  Marketplace: <MarketPlaceIcon heigth={60} width={60} />,
  MentalHealth: <MentalHealthIcon heigth={60} width={60} />,
  Nutrition: <NutritionIcon heigth={52} width={52} />,
  Movement: <MovementsIcon heigth={60} width={60} />,
  Rewards: <RewardsIcon heigth={52} width={52} />,
};

export const APP_DETAILS_ICONS = {
  Marketplace: <MarketPlaceIcon heigth={60} width={60} />,
  MentalHealth: <MentalHealthIcon heigth={60} width={60} />,
  Nutrition: <NutritionIcon heigth={36} width={36} />,
  Movement: <MovementsIcon heigth={60} width={60} />,
  Rewards: <RewardsIcon heigth={52} width={52} />,
};

export const SERVICE_ID = {
  HUSK_ID: 1,
  MARKET_PLACE_ID: 2,
  MENTAL_HEALTH_ID: 3,
  MOVEMENT_ID: 4,
  NUTRITION_ID: 5,
  REWARDS_ID: 6,
};

export const APP_IDS = {
  "/marketplace": 2,
  "/mental-health": 3,
  "/nutrition": 5,
  "/movement": 4,
  "/rewards": 6,
};
